import { randomBytes } from 'crypto';

export default class ConstructorCard {
  /**
   *
   * @param {Number} id
   * @param {Number} type
   * @param {String} title
   * @param {String} description
   *
   * @param {Object} avatar
   * @param {Boolean} avatar.isIcon
   * @param {Object | String} avatar.value
   *
   */
  constructor({
    id, type, title, description, avatar, url, document,
  } = {
    id: null,
    type: null,
    title: null,
    description: null,
    avatar: null,
  }) {
    this.id = id;
    this.hash = randomBytes(20).toString('hex');
    this.type = type;
    this.title = title;
    this.description = description;
    this.avatar = avatar;
    this.url = url;
    this.document = document;
  }

  get isEmpty() {
    return !this.description && !this.title;
  }
}
